import React from 'react'
import Header from '../include/Header'
// import { Link } from 'react-router-dom'
import Footer from '../include/Footer'
function TermsCondition() {
    return (
        <>
            <Header />
            <div className="page-header bg-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="wow fadeInUp" data-cursor="-opaque">Terms & Conditions</h1>
                                {/* <nav className="wow fadeInUp" data-wow-delay="0.2s">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active">Terms & Conditions</li>
                                    </ol>
                                </nav> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-box-content">
                                <div className="section-title">
                                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                                        <b>Effective Date:</b> [Insert Date]
                                        <br /><br />
                                        Welcome to <b>[App Name]</b>, a digital platform operated by
                                        <b> Innosutra AI Private Limited</b> (“Company”, “we”, “our”, or “us”).
                                        <br /><br />
                                        By accessing or using our website https://www.example.com or any related services (collectively, the “Platform”), you agree to comply with and be bound by these Terms and Conditions. If you do not agree, please do not use our Platform.
                                        .
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">1. Definitions</h5>
                                    <p className="wow fadeInUp">
                                        <ul>
                                            <li>“User”, “You”, “Your” refers to any individual accessing or using the Platform.</li>
                                            <li>“Company”, “We”, “Us”, “Our” refers to Innosutra AI Private Limited.</li>
                                            <li>“Services” refers to all features, content, and functionalities provided through [App Name].</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">2. Acceptance of Terms</h5>
                                    <p className="wow fadeInUp">
                                        By using our Platform, you confirm that:
                                        <ul>
                                            <li>You are legally capable of entering into an agreement</li>
                                            <li>You will comply with all applicable laws and these Terms.</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">3. Use of Cookies</h5>
                                    <p className="wow fadeInUp">
                                        We may use cookies and similar technologies to:
                                        <ul>
                                            <li>Improve user experience</li>
                                            <li>Analyze usage patterns</li>
                                            <li>Enable essential features</li>
                                        </ul>
                                        By using our Platform, you consent to the use of cookies in accordance with our Privacy Policy.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">4. Intellectual Property Rights</h5>
                                    <p className="wow fadeInUp">
                                        All content including text, graphics, videos, and software belongs to the Company.
                                        <ul>
                                            <li>No copying or reproduction</li>
                                            <li>No selling or redistribution</li>
                                        </ul>
                                        is owned by or licensed to the Company and protected under applicable intellectual property laws.
                                        <br /><br />
                                        <b>You agree NOT to:</b>
                                        <ul>
                                            <li>Copy, reproduce, or republish content</li>
                                            <li>Sell, rent, or sublicense content</li>
                                            <li>Distribute content without permission</li>
                                        </ul>
                                        Content may only be used for personal, non-commercial purposes unless otherwise authorized.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">5. User-Generated Content</h5>
                                    <p className="wow fadeInUp">
                                        Certain sections of the Platform may allow users to post comments or content.
                                        <br /><br />
                                        By posting content, you confirm:
                                        <ul>
                                            <li>You own or have rights to the content</li>
                                            <li>The content does not violate any laws or third-party rights</li>
                                            <li>The content is not offensive, defamatory, or unlawful</li>
                                        </ul>
                                        You grant the Company a non-exclusive, worldwide, royalty-free license to use, reproduce, and distribute your content.
                                        <br />
                                        We reserve the right to:
                                        <ul>
                                            <li>Monitor user content</li>
                                            <li>Remove content that violates these terms</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">6. Third-Party Links</h5>
                                    <p className="wow fadeInUp">
                                        Our Platform may contain links to third-party websites.
                                        We:
                                        <ul>
                                            <li>Do not control or endorse such websites</li>
                                            <li>Are not responsible for their content or practices</li>
                                        </ul>
                                        Users access third-party links at their own risk.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">7. Linking to Our Platform</h5>
                                    <p className="wow fadeInUp">
                                        Certain organizations may link to our Platform without prior approval, including:
                                        <ul>
                                            <li>Government bodies</li>
                                            <li>Search engines</li>
                                            <li>News platforms</li>
                                        </ul>
                                        Other entities must obtain prior written permission.
                                        <br /><br />
                                        Approved links must:
                                        <ul>
                                            <li>Not be misleading</li>
                                            <li>Not imply endorsement</li>
                                            <li>Fit contextually within the linking site</li>
                                        </ul>
                                        Use of our logo or branding requires explicit permission.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">8. Restrictions on Framing</h5>
                                    <p className="wow fadeInUp">
                                        You may not:
                                        <ul>
                                            <li>Create frames around our website</li>
                                            <li>Alter the visual presentation of the Platform</li>
                                        </ul>
                                        without prior written consent.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">9. Content Liability</h5>
                                    <p className="wow fadeInUp">
                                        We are not responsible for:
                                        <ul>
                                            <li>Content published on third-party websites linking to us</li>
                                        </ul>
                                        You agree to defend and indemnify us against claims arising from your website or content.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">10. Modification of Terms</h5>
                                    <p className="wow fadeInUp">
                                        We reserve the right to:
                                        <ul>
                                            <li>Modify these terms at any time</li>
                                        </ul>
                                        Continued use of the Platform after changes means you accept the revised Terms.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">11. Disclaimer of Warranties</h5>
                                    <p className="wow fadeInUp">
                                        The Platform is provided on an “as is” and “as available” basis.
                                        <br /><br />
                                        <ul>
                                            <li>Accuracy of information</li>
                                            <li>Continuous availability</li>
                                            <li>Error-free operation</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">12. Limitation of Liability</h5>
                                    <p className="wow fadeInUp">
                                        To the maximum extent permitted by law, we shall not be liable for:
                                        <ul>
                                            <li>Any indirect or consequential damages</li>
                                            <li>Loss of data, revenue, or profits</li>
                                        </ul>
                                        Nothing in these Terms limits liability where it is unlawful to do so.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">13. Governing Law</h5>
                                    <p className="wow fadeInUp">
                                        hese Terms shall be governed by and interpreted in accordance with the laws of <b>India.</b><br />
                                        Any disputes shall be subject to the jurisdiction of courts located in [Your City, e.g., Thane].
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">14. Contact Information</h5>
                                    <p className="wow fadeInUp">
                                        For any questions regarding these Terms, you may contact:
                                        <br /><br />
                                        <b>Innosutra AI Private Limited</b>
                                        <br />
                                        Email: innosutraaiprivatelimited@gmail.com
                                        <br />
                                        Phone: 9727555057
                                        <br />
                                        Address: E-213, 21st Floor, ANA Avant Garde, WEH, Shivaji Chowk,
                                        Mira Road, Thane – 401107, Maharashtra, India
                                    </p>
                                </div>
                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default TermsCondition
